import React from 'react';
export function ProductIntroduction() {
  return <div className="space-y-6" data-id="element-260">
      <h2 className="text-3xl font-bold text-gray-900" data-id="element-261">
        The At-Home Device That Opens "Direct-Access Gateways" Through Your Skin
        Barrier
      </h2>
      <div className="w-full aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-262">
        <img src="https://cdn.shopify.com/s/files/1/0619/1693/8405/files/3_573ce0d2-d3ac-4956-99ec-924708da2e99.png?v=1762315368" alt="Micro-infusion device with clinical presentation" className="w-full h-full object-cover rounded-lg" data-id="element-263" />
      </div>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-264">
        She introduced me to a revolutionary micro-infusion device that uses
        hollow microneedles to create hundreds of tiny channels through the
        Permeability Wall.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-265">
        These aren't like the derma-rollers you might have seen online. Those
        just scratch the surface.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-266">
        This device uses patented hollow needle technology to:
      </p>
      <ol className="list-decimal list-inside space-y-3 pl-4" data-id="element-267">
        <li className="text-lg text-gray-800 leading-relaxed" data-id="element-268">
          Create Direct-Access Gateways through your skin's protective barrier
        </li>
        <li className="text-lg text-gray-800 leading-relaxed" data-id="element-269">
          Deliver clinical-grade ingredients directly into living skin where
          they can actually work
        </li>
        <li className="text-lg text-gray-800 leading-relaxed" data-id="element-270">
          Bypass the 99.7% waste that happens with regular skincare
        </li>
      </ol>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-271">
        <b data-id="element-272">
          It's the same technology used in medical spas and dermatology
          clinics—but you can use it at home in just 5 minutes, once a month.
        </b>
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-273">
        No appointments. No downtime. No $500 sessions.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-274">
        At first, I was skeptical. Could an at-home device really deliver
        professional results?
      </p>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-275">
        But the science was solid. And more importantly, the before-and-after
        photos were undeniable...
      </p>
    </div>;
}